<template>
  <v-container fluid>
    <h2 class="d-flex justify-space-between">Product Search History</h2>
    <div class="d-flex">
      <v-spacer />
      <v-btn class="ma-2" color="primary" @click="downloadExcel">
        <v-icon>mdi-table</v-icon>
      </v-btn>
    </div>
    <select-artist
      :useActiveArtist="false"
      @onChange="handleArtistChange"
    ></select-artist>
    <v-data-table
      :headers="headers"
      :items="products"
      :disable-pagination="true"
      :hide-default-footer="true"
      :loading="loading"
      loading-text="Crunching data ... Please wait"
      class="elevation-1"
    >
      <template v-slot:[`item.value.product`]="{ item }">
        <template
          v-if="['ProductClicked', 'ProductNext', 'ProductPrev'].includes(item.name)"
        >
          {{ item.value }}
        </template>
        <template v-if="item.name === 'ProductAddedToCart'">
          <pre>{{ value }}</pre>
          <p v-for="product of item.value">
            {{ product.sku }}
          </p>
        </template>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import ReportApi from "@/api/admin/report";
import xlsx from "xlsx";
import SelectArtist from "@/components/SelectArtist";

export default {
  components: {
    SelectArtist,
  },
  data() {
    return {
      imageUrl: process.env.VUE_APP_IMG_URL,
      products: [],
      loading: false,
      artist: null,
      // filteredArtworks: [],
      headers: [
        {
          text: "Email",
          value: "email",
        },
        {
          text: "Event",
          sortable: true,
          value: "name",
        },
        {
          text: "Product",
          sortable: true,
          value: "value.product",
        },
        {
          text: "Search",
          sortable: true,
          value: "value.searchText",
        },
        {
          text: "Categories",
          sortable: true,
          value: "value.category",
        },
        {
          text: "Artists",
          sortable: true,
          value: "value.artist",
        },
        // {
        //   text: "Subject Matter",
        //   sortable: true,
        //   value: "value.subjectMatter",
        // },
        // {
        //   text: "Regions",
        //   sortable: true,
        //   value: "value.regions",
        // },
        {
          text: "Results",
          sortable: true,
          value: "value.results",
        },
      ],
    };
  },
  methods: {
    async getSearches() {
      this.loading = true;
      ReportApi.loadProductSearches().then((results) => {
        this.products = results.data;
        this.loading = false;
      });
    },
    downloadExcel() {
      const headers = ["email", "name", "value", "timestamp"];
      const workbook = xlsx.utils.book_new();
      const worksheet = xlsx.utils.json_to_sheet(this.products, { header: headers });
      xlsx.utils.book_append_sheet(workbook, worksheet, "Sales");
      xlsx.writeFile(workbook, `${this.artist}-PRODUCT-PERFORMANCE.xlsx`);
    },
    async handleArtistChange(evt) {
      this.artist = evt.name;
      await this.getSearches(evt.artistCode);
    },
  },
  computed: {},
  async mounted() {},
};
</script>
